import { render, staticRenderFns } from "./usdtlist.vue?vue&type=template&id=27c45e8e&scoped=true"
import script from "./usdtlist.vue?vue&type=script&lang=js"
export * from "./usdtlist.vue?vue&type=script&lang=js"
import style0 from "./usdtlist.vue?vue&type=style&index=0&id=27c45e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c45e8e",
  null
  
)

export default component.exports